export default __webpack_public_path__ + "static/media/a7edca698349b80c0c7fe8cba2f76aac.062f009f.svg";